// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__-yIp1","footer":"ModalCreateQualiphyProcedure_footer__1oitt","additionData":"ModalCreateQualiphyProcedure_additionData__1jZtq"};